import styled from "styled-components";

export const WidgetCard = styled.div`
  background: ${({ theme }) => theme.colors.darkerNed};
  border-radius: 12px;
  overflow: hidden;
  padding: 16px;
`;

export const WidgetHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
`;

export const WidgetTitle = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.colors.ice};
  display: flex;
  font-size: 14px;
  font-weight: 700;
  gap: 8px;
`;

export const WidgetHeaderAction = styled.span`
  color: ${({ theme }) => theme.colors.chalk};
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;

  &:hover {
    color: ${({ theme }) => theme.colors.envy};
  }
`;

export const WidgetTag = styled.span`
  background: rgba(143, 169, 175, 0.14);
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.chalk};
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  padding: 3px 7px;
  text-transform: uppercase;
`;
